import { FC, useCallback, useState } from "react";
import { styled } from "styled-components";
import { InputGroup, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Wrapper = styled(InputGroup)`
    width: fit-content;
    border-radius: 8px;
`;

const PasswordText = styled.span<{ $visible: boolean }>`
    font-family: monospace;
    padding: 5px 10px;
    border: 1px solid #dedede;
    border-right: none;
    border-radius: 8px 0 0 8px;
    display: flex;
    align-items: center;
    user-select: ${({ $visible }) => ($visible ? "text" : "none")};
`;

const ToggleButton = styled(Button)`
    && {
        border-radius: 0 8px 8px 0;
        border: 1px solid #dedede;
        padding: 5px 10px;
        display: flex;
        align-items: center;
    }
`;

type Props = {
    password: string;
};

export const RevealablePassword: FC<Props> = ({ password }) => {
    const [visible, setVisible] = useState(false);

    const obfuscated = "•".repeat(password.length);

    const handleToggle = useCallback(() => setVisible((v) => !v), [setVisible]);

    return (
        <Wrapper>
            <PasswordText $visible={visible} aria-label="password value">
                {visible ? password : obfuscated}
            </PasswordText>

            <ToggleButton
                variant="outline-secondary"
                onClick={handleToggle}
                aria-label={visible ? "Hide password" : "Show password"}
                title={visible ? "Hide password" : "Show password"}
            >
                {visible ? <FaEyeSlash /> : <FaEye />}
            </ToggleButton>
        </Wrapper>
    );
};
